import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const passwordViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map